import { useState, useEffect } from "react";
/**
 * Custom hook to check if the window width is less than the specified maxWidth.
 * @param {number} maxWidth - The maximum width to compare against.
 * @returns {boolean} - Returns true if the window width is less than maxWidth, false otherwise.
 */
function useMediaQuery(maxWidth: number) {
	const [matches, setMatches] = useState(false);

	useEffect(() => {
		const handleResize = () => {
			setMatches(window.innerWidth < maxWidth);
		};

		handleResize();

		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, [maxWidth]); // Re-run effect if maxWidth changes

	return matches;
}

export default useMediaQuery;
